module.exports = __webpack_public_path__ + "img/parking.4c525ce8.png";